import * as commentTypes from './types/comment.types.js';
import axios from 'axios';
import { notification } from 'antd';

const baseUrl = process.env.REACT_APP_API_URL;
const config = {
  headers: { Authorization: '' },
};

export const addComment = (msg, id) => {
  return async (dispatch) => {
    try {
      const data = {
        messageDescription: msg,
        messageId: id,
      };
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.post(`${baseUrl}/messages/add`, data, config);
      dispatch({
        type: commentTypes.COMMENT_SUCCESS,
        payload: res.data.data,
      });
      notification.success({
        message: 'Message Sent',
        placement: 'bottomRight',
      });
    } catch (error) {
      dispatch({
        type: commentTypes.COMMENT_ERROR,
        payload: error,
      });
      notification.error({
        message: 'Oops! somthing Went Wrong',
        placement: 'bottomRight',
      });
    }
  };
};

export const deleteComment = (id, callback) => async (dispatch) => {
  try {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    const res = await axios.delete(`${baseUrl}/messages/${id}`, config);
    dispatch({
      type: commentTypes.COMMENT_SUCCESS,
      payload: res.data.data,
    });
    callback();
  } catch (error) {
    dispatch({
      type: commentTypes.COMMENT_ERROR,
      payload: error,
    });
  }
};
